import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import globalNav from "./components/Nav.vue";
import VueCookies from "vue-cookies";
import userCode from "@/util/allCode.js";
import './assets/iconfont/font/iconfont.css'

import { navList } from "@/util/api.js";
import codeings from "@/util/code.js"
import "reset-css";
import Print from "vue-print-nb";
import vueEsign from "vue-esign";
Vue.use(vueEsign);
Vue.use(Print);
Vue.use(ElementUI);
Vue.use(VueCookies);
Vue.component("globalNav", globalNav);
import axios from "axios";
Vue.prototype.$axios = axios;
import $ from "jquery";
Vue.prototype.$ = $;
import "@/components";
Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  checkLogin(to, next);
  // next()
});
function pcUrl() {
  let geturl = window.location.href;
  let getqyinfo = geturl.split("?")[1];
  let getqys = new URLSearchParams("?" + getqyinfo);
  let getqycode = getqys.get("SSOID");
  return getqycode;
}
function clearLogin() {
  store.state.isLogin = false;
  store.state.cookie = "";
  store.state.userinfo = {};
  store.state.userName = "";
  clearDomain();
}
// app使用h5页面
function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return r[2];
  return null;
}
// 年月日时分秒
function getNowFormatDate() {
  var date = new Date();
  var seperator1 = "-";
  var seperator2 = ":";
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate =
    date.getFullYear() +
    seperator1 +
    month +
    seperator1 +
    strDate +
    " " +
    date.getHours() +
    seperator2 +
    date.getMinutes() +
    seperator2 +
    date.getSeconds();
  return currentdate;
}
function checkLogin(to, next) {
  let SSOID = GetQueryString("SSOID") || pcUrl() || $cookies.get("SSOID");
  var url = "https://sso.chci.cn/ssoJsonLogin.do";
  if (SSOID) {
    console.log("有SSOID", SSOID);
    url = "https://sso.chci.cn/ssoJsonLogin.do?ticket=" + SSOID;
  }
  console.log(url);
  $.ajax({
    //备用请求 和下面的vue-jsop实际效果是一样的  只不过这个是jq
    url: url,
    type: "GET",
    async: false,
    dataType: "jsonp",
    jsonp: "mycallback",
    xhrFields: {
      withCredentials: true, //解决跨服务传递时不传递cookie的问题，允许携带证书
    },
    crossDomain: true, //允许跨域
    timeout: 5000,
    success: async function (data) {
      console.log("[ data ] >", data);
      // 不需要登录的界面
      // 没有登录
      if (data.error) {
        store.state.onceRequest=false//让登录接口掉用一次只
        store.commit("closeAllTab")//账号失效清空上面的tab
        // 去登录界面
        let returnUrl = encodeURIComponent(window.location.href);
        window.location.href =
          "https://sso.chci.cn/login.do?method=get&returnURL=" + returnUrl;
        return;
      }
      await  setDomainCookie(data);
      if (to.path == "/noper") {
        await judgePer(next, to);
      }
      await saveNavCode(next, to);
      // logingsLog();
      // ----- 调取接口  存store侧边栏  处理 地址路由
    },
  });
}
//没权限退出登录 在登录有权限的 防止sso跳回来
async function judgePer(next, to) {
  let data = await navList(
    { userName: $cookies.get("username") },
    $cookies.get("SSOID")
  );
  if (data.success) {
    let routerCode
    if(data.result.permissionCode=="All"){
      routerCode=codeings
    }else{
      routerCode = data.result.permissionCode.split(",");
    }
    sessionStorage.setItem("isHm", JSON.stringify(data.result.isHm));
    sessionStorage.setItem("navCode", JSON.stringify(routerCode));
    $cookies.set("isAdmins", data.result.isAdmin, "0"); 
    $cookies.set("companyName", data.result.companyName, "0"); 
    let redirectPath;
    userCode.map((item) => {
      if (item.code == routerCode[0]) {
        redirectPath = item.path;
      }
    });
    // 退出登录换账号 当前路由没有权限 去自己的页面
    return next(redirectPath);
  } else {
    return next();
  }
}
async function saveNavCode(next, to) {
  let data = await navList(
    { userName: $cookies.get("username") },
    $cookies.get("SSOID")
  );
  if (data.success) {
    let routerCode
    if(data.result.permissionCode=="All"){
      routerCode=codeings
    }else{
      routerCode = data.result.permissionCode.split(",");
    }
    store.state.adCode = routerCode;
    sessionStorage.setItem("isHm", JSON.stringify(data.result.isHm));
    sessionStorage.setItem("navCode", JSON.stringify(routerCode));
    $cookies.set("isAdmins", data.result.isAdmin, "0"); 
    $cookies.set("companyName", data.result.companyName, "0"); 
    store.state.adCode = routerCode;
    let redirectPath;
    let rolePath = [];
    userCode.map((item) => {
      if (item.code == routerCode[0]) {
        redirectPath = item.path;
      }
      if (routerCode.indexOf(item.code) != -1) {
        rolePath.push(item.path);
      }
    });
    if (to.path == "/") {
      next(redirectPath);
    } else {
      if (rolePath.indexOf(to.path) != -1) {
        next();
      } else {
        // 这里还要加个条件
        if (to.path=="/stock/finished"||to.path=="/stock/firmGoods"||to.path=="/material/materhouse"||to.path == "/stock/warehousing" || to.path == "/stock/outhousing"|| to.path == "/customerDetail"|| to.path == "/orderDeatile"||to.path=="/material/materOut") {
          next();
        } else {
          next(redirectPath);
        }
      }
    }
  } else {
    next("/noper");
  }
}
function setDomainCookie(data) {
  store.state.userinfo = data;
  $cookies.set("SSOID", data.ticketVo.ticketEncryptKey, "0"); ///保存请求返回所有信息
  $cookies.set("username", data.ticketVo.username, "0"); ///保存请求返回所有信息
  $cookies.set("isLogin", true, "0"); ///保存请求返回所有信息
  $cookies.set("areaLayer", data.user.kqlayer, "0"); ///保存请求返回所有信息
  setDomainStoreState();
}

function setDomainStoreState() {
  store.state.isLogin = $cookies.get("isLogin");
  store.state.SSOID = $cookies.get("SSOID"); //所属管理地区
  store.state.username = $cookies.get("username"); //保存请求返回所有信息
}
function clearDomain() {
  $cookies.remove("isLogin");
  $cookies.remove("SSOID");
  $cookies.remove("username");
  $cookies.remove("areaLayer");

  store.state.isLogin = $cookies.get("isLogin"); //所属管理地区
  store.state.SSOID = $cookies.get("SSOID"); //保存请求返回所有信息
  store.state.username = $cookies.get("username"); //保存地区编码
  store.state.areaLayer = $cookies.get("areaLayer"); //保存地区编码
}
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
